import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'LengthAndHeight',
  field: 'Measurement',
  weeks: [8, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'MeasureInCentimetres',
      questionTypes: ['bjs', 'bjt', 'bju'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/1MeasureInCentimetres" */ './1MeasureInCentimetresModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'MeasureInMetres',
      questionTypes: ['bjv', 'bjw', 'bjx'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/2MeasureInMetres" */ './2MeasureInMetresModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'CompareLengthsAndHeights',
      questionTypes: ['bjy', 'bjz', 'bjA'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/3CompareLengthsAndHeights" */ './3CompareLengthsAndHeightsModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'OrderLengthsAndHeights',
      questionTypes: ['bjB', 'bjC', 'bjD'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/4OrderLengthsAndHeights" */ './4OrderLengthsAndHeightsModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'FourOperationsWithLengthsAndHeights',
      questionTypes: ['bjE', 'bjF', 'bjG'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/5FourOperationsWithLengthsAndHeights" */ './5FourOperationsWithLengthsAndHeightsModels'
        )
    })
  ]
});
export default Block;
